import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "users" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "type-data" }
const _hoisted_6 = { class: "first-column-with-icon-type" }
const _hoisted_7 = { class: "name-type-block" }
const _hoisted_8 = {
  key: 0,
  class: "type-data-block"
}
const _hoisted_9 = {
  key: 1,
  class: "type-data-block"
}
const _hoisted_10 = {
  key: 2,
  class: "type-data-block"
}
const _hoisted_11 = {
  key: 3,
  class: "type-data-block"
}
const _hoisted_12 = { class: "emq-table-footer" }

import { getEvseRunlogList } from '@/api/evses'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { ElMessage, ElMessageBox } from 'element-plus'
import { dateFormat, throttleBtn } from '@/common/tools'
import EvseRunLogUpload from './EvseRunLogUpload.vue'
import UploadFileStatus from '@/components/UploadFileStatus.vue'
import { checkMenuShow } from '@/store/tool'


import { defineComponent, ref, defineProps } from 'vue'

const __default__ = defineComponent({
  name: 'EvseRunLog',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  evse: {
    type: Object,
    default: () => {},
  },
},
  setup(__props) {

const props = __props



const { t } = useI18nTl('Operation')

const showCard = ref({})
const showDialog = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')

const uploadLogs = () => {
  showCard.value = {}
  showDialog.value = true
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadTabdatas()
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { No, operatorID, enable } = params
  newParams = {
    No: No || undefined,
    operatorID: operatorID || undefined,
    enable: enable || undefined,
  }
  return newParams
}

const loadTabdatas = async () => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
    },
    evseId: props.evse.id,
  }

  try {
    const { list = [], pageReply = {} } = await getEvseRunlogList(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadTabdatas)

loadTabdatas()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (uploadLogs()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.diagnostics')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'driverCardUpsert']
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])), [
          [_directive_role, 'evseRunLogUpload']
        ])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "id"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "ban",
            label: _ctx.$t('Base.diagnosticsAt')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "address",
            "min-width": "200",
            label: _ctx.$t('Base.address'),
            show: "false"
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "chargingbeginTime",
            "min-width": "80",
            label: _ctx.$t('Base.rangeTime')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  (row.beginTime > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(dateFormat)(Number(row.beginTime) * 1000)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_9, "-")),
                  (row.endTime > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(dateFormat)(Number(row.endTime) * 1000)), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, "-"))
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            "min-width": "50",
            label: _ctx.$t('Evses.state'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(UploadFileStatus, {
                state: row.state
              }, null, 8, ["state"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[1] || (_cache[1] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadTabdatas
        }, null, 8, ["metaData"])
      ])
    ]),
    _createVNode(EvseRunLogUpload, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showDialog).value = $event)),
      evse: props.evse,
      onSubmitted: loadTabdatas
    }, null, 8, ["modelValue", "evse"])
  ]))
}
}

})